import { Component } from '@angular/core';
import { Platform, NavController, NavParams, ViewController, Events, AlertController } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { AppSettings } from '../../../../config/app-settings';
import { ForgotPasswordCommon } from './forgot-password.common';
import { PageBase } from '../../../../core/page-base';

@Component({
	selector: 'page-forgot-password',
	templateUrl: 'forgot-password.html'
})

export class ForgotPasswordPage  extends PageBase {
	public forgotPass: {email?: string} = {};
	public submitted = false;
    public errorMsg:string;
	
	constructor(
		public nav: NavController,
		public platform: Platform,
    	public params: NavParams,
    	public viewCtrl: ViewController,
    	public events: Events,
    	public userData: UserData,
    	public alertCtrl: AlertController,        
        public settings: AppSettings,        
        public common: ForgotPasswordCommon,
    ) {
        super(settings, events, nav, userData);
        console.log("Loading Password Mobile");
	}

    public send(form){
    	let self = this;
    	this.userData.sendPasswordResetEmail(this.forgotPass.email).subscribe((res)=>{
    		let alert;
    		if(!res.success){
                this.errorMsg=res.msg;
    			return false;
    		}
            this.errorMsg = '';
    		alert = this.alertCtrl.create({
    			title: '',
    			subTitle: 'Password reset link has been sent to your email address',
    			buttons: [{
                    text: 'OK',
                    handler: data=>{
                        self.nav.pop();
                    }
                }]

    		});
    		alert.present();
    	});
    }

    public dismiss() {
        this.viewCtrl.dismiss();
    }
}



// WEBPACK FOOTER //
// ./src/modules/account/pages/forgot-password/forgot-password.ts